import gameData from "./gameData";

export function getAsset(scene, assetName) {
  return scene.cache.json.get(assetName);
};

export function getGameDataProp(scene, propname) { // Just changing this to point to global level var
  if (gameData.isAlphabet) {
    return getAsset(scene, "alphabet")[propname];
  }
  return getAsset(scene, "level" + gameData.levelInfo.currentLevel)[propname];
};

export function getLevelDataProp(scene, level, propname) {
  return getAsset(scene, level)[propname];
};